import React from 'react';

import WarningIcon from 'assets/LeadInfo/warning.svg';
import { formatDateTime } from 'utils/dateUtils';

import {
  ContactContent,
  ContactFildes,
  ContactInputBox,
  ContactTitle,
  InputContent,
  InputLabel,
  TitleIcon,
} from './CompetitorInfo.styles';

const CompetitorInfo = ({ leadData }) => {
  const hasCompetitorInfo =
    leadData?.competitorId ||
    leadData?.includedServices ||
    leadData?.tariff ||
    leadData?.contractEndDate;

  if (!hasCompetitorInfo) return null;

  return (
    <ContactContent>
      <ContactTitle>
        <TitleIcon src={WarningIcon} />
        Competitor Information
      </ContactTitle>
      {(leadData?.competitor?.name || leadData?.includedServices) && (
        <ContactFildes>
          {leadData?.competitor?.name && (
            <ContactInputBox>
              <InputLabel>Current Provider</InputLabel>
              <InputContent>{leadData.competitor.name}</InputContent>
            </ContactInputBox>
          )}
          {leadData?.includedServices && (
            <ContactInputBox>
              <InputLabel>Included Services</InputLabel>
              <InputContent>{leadData.includedServices}</InputContent>
            </ContactInputBox>
          )}
        </ContactFildes>
      )}
      {leadData?.tariff && (
        <ContactFildes>
          <ContactInputBox>
            <InputLabel>Tariff</InputLabel>
            <InputContent>{leadData.tariff}</InputContent>
          </ContactInputBox>
        </ContactFildes>
      )}
      {(leadData?.contactDate || leadData?.contractEndDate) && (
        <ContactFildes>
          {leadData?.contactDate && (
            <ContactInputBox>
              <InputLabel>Contract Date</InputLabel>
              <InputContent>{formatDateTime(leadData.contactDate)}</InputContent>
            </ContactInputBox>
          )}
          {leadData?.contractEndDate && (
            <ContactInputBox>
              <InputLabel>Contract End Date</InputLabel>
              <InputContent>{formatDateTime(leadData.contractEndDate)}</InputContent>
            </ContactInputBox>
          )}
        </ContactFildes>
      )}
    </ContactContent>
  );
};

export default CompetitorInfo;
